
import { User } from '@/types/user';
import { updateUserName as updateNameInDb } from '@/utils/supabase/auth';
import { toast } from '@/hooks/use-toast';

export const useUpdateProfile = (
  user: User | null,
  setUser: React.Dispatch<React.SetStateAction<User | null>>
) => {
  const updateUserName = async (userId: string, newName: string): Promise<boolean> => {
    try {
      console.log('Updating user name for userId:', userId, 'newName:', newName);
      
      if (!userId || !newName?.trim()) {
        console.error('Invalid userId or newName provided');
        toast({
          title: 'Validation Error',
          description: 'Please provide a valid name.',
          variant: 'destructive',
        });
        return false;
      }

      const success = await updateNameInDb(userId, newName.trim());
      if (success) {
        console.log('Successfully updated user name in database');
        if (user && user.id === userId) {
          setUser({ ...user, name: newName.trim() });
        }
        toast({
          title: 'Profile Updated',
          description: 'Your profile has been updated successfully.',
        });
        return true;
      }
      throw new Error('Failed to update profile in database');
    } catch (error: any) {
      console.error('Failed to update user name:', error);
      toast({
        title: 'Profile Update Failed',
        description: error.message || 'Please try again.',
        variant: 'destructive',
      });
      return false;
    }
  };

  return { updateUserName };
};
